var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gruppenDescription"},[_c('h6',[_vm._v(_vm._s(_vm.getHeading))]),_vm._l((_vm.qualificationIds),function(quali){return _c('label',{key:quali},[_vm._v(_vm._s(_vm.getQualificationName(quali)))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }